export default {
  en: {
    'components.company-sign-up-form.question-one': "What's the company name?",
    'components.company-sign-up-form.question-one.placeholder': 'Company name',
    'components.company-sign-up-form.question-two': "What's the company address?",
    'components.company-sign-up-form.fields.company-name': 'Company name',
    'components.company-sign-up-form.fields.tax-number': 'Tax number',
    'components.company-sign-up-form.fields.street-name': 'Street name',
    'components.company-sign-up-form.fields.building-number': 'Building number',
    'components.company-sign-up-form.fields.post-code': 'Post code',
    'components.company-sign-up-form.fields.city': 'City',
    'components.company-sign-up-form.fields.country': 'Country',
  },
};
